import { render, staticRenderFns } from "./myShopOrderMsg.vue?vue&type=template&id=75f43b13&scoped=true"
import script from "./myShopOrderMsg.vue?vue&type=script&lang=js"
export * from "./myShopOrderMsg.vue?vue&type=script&lang=js"
import style0 from "./myShopOrderMsg.vue?vue&type=style&index=0&id=75f43b13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f43b13",
  null
  
)

export default component.exports